module.exports = __webpack_public_path__ + "static/media/icon_checkbox.c8547b1f.svg";